/* eslint-disable react/prop-types */

import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import SpinnerLarge from '../components/SpinnerLarge'
import React, { useEffect, useState } from 'react'
import checkIsUserLoggedIn from '../navigation/checkIsUserLoggedIn'

export const LaunchDarklyWrapper = ({ children }) => {
  const [LDProvider, setLDProvider] = useState(null)

  useEffect(() => {
    const initializeLD = async () => {
      try {
        console.log("Initializing LaunchDarkly provider...")
        // Returning logged-in users must evaluate flags as their own context,
        // not the anonymous one — resolve the Cognito session before init so
        // flags are right from the first evaluation (the app reads them via
        // ldClient.variation() with no re-render subscription).
        let context // undefined → SDK uses its persisted anonymous context
        try {
          const user = await checkIsUserLoggedIn()
          const sub = user?.signInUserSession?.idToken?.payload?.sub
          if (sub) {
            context = { kind: 'user', key: sub, anonymous: false }
          }
        } catch (error) {
          // fall through to anonymous
        }
        const ProviderComponent = await asyncWithLDProvider({
          clientSideID: `${process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID}`,
          ...(context && { context }),
          options: {
            plugins: [],
          }
        })

        setLDProvider(() => ProviderComponent)
        console.log("LaunchDarkly provider initialized successfully.")

      } catch (error) {
        console.error("Failed to initialize LaunchDarkly provider:", error)
      }
    }

    initializeLD()
  }, [])
  
  if (!LDProvider) {
    return <SpinnerLarge />
  } else {
    return (
      <LDProvider>
        {children}
      </LDProvider>
    )
  }
}